import { createContext } from 'react';

export interface ILoaderContext {
  loading: boolean
  setLoading: (isLoading: boolean) => void
}

const LoaderContext = createContext<ILoaderContext>({
  loading: false,
  setLoading: () => null,
});

export default LoaderContext;
